import React from "react";
import { Field } from "formik";
import Input from "../../DataEntry/Input";

export default class Row extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { alarm, label, name, md = 4, ...props } = this.props;

    return (
      <div className="row">
        <div className="col-xs-1 text-right">{alarm}</div>
        <div className={`col-xs-11 col-md-${md} no-padding`}>
          <label htmlFor={name}>{label}</label>
        </div>
        <div className="col-xs-1"></div>
        <div className={`col-xs-11 col-md-${10 - md} no-padding`}>
          <Field
            name={name}
            className="smart-form-control"
            component={Input}
            {...props}
          />
        </div>
      </div>
    );
  }
}
